export default __webpack_public_path__ + "static/media/Turn.e7ca2f48.svg";